import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeSentry } from './lib/sentry';
import AuthProviderWrapper from './components/auth/AuthProviderWrapper';
// Design-system tokens (global CSS custom properties; inert until referenced)
import './design-system/tokens.css';
// Side-effect import: initialises PostHog if REACT_APP_POSTHOG_KEY and
// REACT_APP_POSTHOG_HOST are both set. No-ops otherwise.
import './posthog';

// Initialize Sentry before rendering the app
async function initializeApp() {
  try {
    console.log('Initializing Sentry...');
    initializeSentry();
    console.log('Sentry initialized successfully');
  } catch (error) {
    console.error('Failed to initialize services:', error);
  } finally {
    // Render the app regardless of initialization success/failure
    console.log('Rendering React app...');
    const root = ReactDOM.createRoot(
      document.getElementById('root') as HTMLElement,
    );
    root.render(
      <React.StrictMode>
        <AuthProviderWrapper>
          <App />
        </AuthProviderWrapper>
      </React.StrictMode>,
    );
  }
}

// Start the initialization process
initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
